import { generate } from '@/utils/request';
const config = {
  prefix: '/hagd/v1',
  items: [
    {
      key: 'getInstancesList',
      url: '/sagas/instances',
      method: 'get',
    },
    {
      key: 'getInstancesDetail',
      url: '/sagas/instances/{id}',
      method: 'get',
    },
    {
      key: 'retryInstancesTask',
      url: '/sagas/tasks/instances/{id}/retry',
      method: 'put',
    },
    {
      key: 'failedInstancesTask',
      url: '/sagas/tasks/instances/{id}/failed',
      method: 'put',
    },
    {
      key: 'InstancesRePush',
      url: '/sagas/tasks/instances/byInnerOrderIdRetry?innerOrderNo={innerOrderNo}',
      method: 'get',
    },
    {
      key: 'getTaskInstanceMessage',
      url: '/sagas/tasks/instances/getTaskInstanceByInnerOrderNo',
      method: 'get',
    },
  ],
};

export default {
  ...generate(config),
};
